import { Component, OnInit, AfterViewInit } from '@angular/core';

import { VendaService } from '../../../../shared/services/venda/venda.service';
import { LocalStorageService } from '../../../../shared/services/local-storage/local-storage.service';

import * as moment from 'moment';
import * as Taggle from 'taggle';

declare var $: any;

@Component({
  selector: 'app-vendas',
  templateUrl: './vendas.component.html',
  styleUrls: ['./vendas.component.scss']
})
export class VendasComponent implements OnInit, AfterViewInit {
  public table: any;

  public error = false;
  public loaded = false;

  public tagglejs: any = null;

  public inputSearch = '';

  public vendas: any[] = [];
  public _vendas: any[] = [];
  public hidden: boolean = true;

  request: any;

  public page = 1;

  user: any;
  lastSelection: any;
  firstSelection: any;

  initialDate: Date = moment().subtract(1, 'months').toDate();
  finalDate: Date = moment().toDate();

  isClick = false;

  isLoading = false;

  showModal = false;

  sale: any = false;

  alertCancelarVenda = false;
  cancelandoVenda = false;
  vendaCancelada = false;

  alertReativarVenda = false;

  boxHidden = true;

  firstRequest = true;

  public status: any = [
    { name: 'Ativa', className: 'status-ativa', actived: false },
    { name: 'Aberta', className: 'status-aberta', actived: false },
    { name: 'Recebida', className: 'status-recebida', actived: false },
    { name: 'Cancelada', className: 'status-cancelada', actived: false },
    { name: 'Agendada', className: 'status-agendada', actived: false },
  ];

  constructor(
    private vendaService: VendaService,
    private localStorageService: LocalStorageService,
  ) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.setTaggle();
    this.clickOutListener();
  }

  clickOutListener() {
    const self = this;
    document.addEventListener('click', function(e: any) {
      if (e.target.closest('.box-filter')) { return; }

      if (!self.boxHidden && !e.target.closest('.filter-icon')) {
        self.toggleBox();
      }
    });
  }

  setFilterData(e?: any) {
    const user = this.localStorageService.get('login');
    if (!user || !user.PersonId) { return; }

    this.page = 0;
    this.user = user;

    if (e) {
      this.firstSelection = e.firstSelection;
      this.lastSelection = e.lastSelection;
    }

    this.error = false;
    this.getVendas(0);
  }

  getUser() {
    return this.localStorageService.get('login');
  }

  setTaggle() {
    const self = this;

    this.tagglejs = new Taggle('input-tag', {
      onTagAdd: function() { },
      onTagRemove: function(e, tag) {
        self.markTagAsInactive(tag);
      },
      placeholder: '',
      maxTags: 2,
      preserveCase: true,
    });
  }

  getVendas(numeroPagina: number) {
    this.error = false;
    this.loaded = false;

    this.showData();

    const dataInicio = new Date(this.firstSelection.year, this.firstSelection.month - 1, this.firstSelection.day).toDateString();
    const dataFim = new Date(this.lastSelection.year, this.lastSelection.month - 1, this.lastSelection.day).toDateString();

    $('#master-detail-table-vendas_wrapper').hide();

    this.vendaService.obterPorContaId(this.getUser().PersonId, dataInicio, dataFim, numeroPagina).subscribe((data: any) => {
      if (data && data.Vendas && data.Vendas.length === 0) {
        this.error = true;
        this.loaded = false;

        return;
      }

      $('#master-detail-table-vendas_wrapper').show();

      this.error = false;
      this.loaded = true;
      this.vendas = data.Vendas;

      this.request = data;

      this.vendas.sort(function(a, b) {
        const dateA = a.DataCadastro;
        const dateB = b.DataCadastro;
        if (moment(dateA).isAfter(dateB)) { return -1; }
        if (!moment(dateA).isAfter(dateB)) { return 1; }
        return 0;
      });

      this.vendas.forEach((venda: any) => {
        venda.DataCadastro = moment(venda.DataCadastro).format('DD/MM/YYYY');
        venda.Valor = venda.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

        venda.Cobrancas.sort(function(a: any, b: any) {
          if (moment(a.DataCobranca).isAfter(b.DataCobranca)) { return 1; }
          if (!moment(a.DataCobranca).isAfter(b.DataCobranca)) { return -1; }
          return 0;
        });
      });

      this._vendas = JSON.parse(JSON.stringify(this.vendas));
      if (this.firstRequest) {
        // this.addTag('Ativa');
        // this.markTagAsActive('Ativa');

        this.firstRequest = false;
      }

      this.filter();
      this.showData();
    }, (err) => {
      this.error = true;
      console.error(err);
    });
  }

  showData() {
    const self = this;
    $.fn.dataTable.moment('DD/MM/YYYY');

    this.table = $('#master-detail-table-vendas').DataTable({
      scrollX: true,
      destroy: true,
      paging: true,
      pagingType: 'numbers',
      pageLength: 26,
      lengthChange: false,
      searching: false,
      processing: false,
      info: true,
      data: self.vendas,
      bSort: false,
      language: {
        emptyTable: ' ',
        info: '_START_ - _END_ de _MAX_',
      },
      initComplete: function(e: any) {
        self.loaded = true;

        $('.paging_numbers').show();
        $('.dataTables_info').show();
      },
      columns: [
        {
          width: '250px',
          title: 'Cliente',
          data: null,
          render: function(data: any, type: any, row: any) {
            if (row && row.Cliente && row.Cliente.Nome) {
              return row.Cliente.Nome;
            }

            return '';
          }
        },
        { title: 'Cadastro', data: 'DataCadastro' },
        {
          title: 'Descrição',
          data: null,
          render(data: any, type: any, row: any) {
            const descricao = row.Descricao ? row.Descricao : '';
            return descricao.slice(0, 50) + (descricao.length >= 50 ? '...' : '');
          }
        },
        {
          class: 'status',
          title: 'Status',
          data: null,
          render(data: any, type: any, row: any) {
            const statusAtiva = '<span class="status-ativa">Ativa</span>';
            const statusAberta = '<span class="status-aberta">Aberta</span>';
            const statusRecebida = '<span class="status-recebida">Recebida</span>';
            const statusCancelada = '<span class="status-cancelada">Cancelada</span>';
            const statusAgendada = '<span class="status-agendada">Agendada</span>';

            if (self.temCobrancaRecebida(row) && row && row.Situacao !== 'Cancelada') {
              return statusAtiva;
            }

            switch (row.Situacao) {
              case 'Aberta':
                return statusAberta;
              case 'Recebido':
                return statusRecebida;
              case 'Cancelada':
                return statusCancelada;
              case 'Agendada':
                return statusAgendada;
              default:
                return '';
            }
          }
        }
      ],
    });

    this.rowClickListener();
  }

  rowClickListener() {
    const self = this;
    $('#master-detail-table-vendas tbody').on('click', 'tr', function() {
      const data = self.table.row(this).data();
      self.sale = data;
      self.showModal = true;
    });
  }

  eventClose() {
    this.showModal = false;
  }

  openModal() {
    this.showModal = true;
  }

  getSaleStatus() {
    if (!this.sale) { return { title: null, className: null }; }

    if (this.temCobrancaRecebida(this.sale) && this.sale && this.sale.Situacao !== 'Cancelada') {
      return { title: 'Venda Ativa', className: 'venda-ativa' };
    }

    switch (this.sale.Situacao) {
      case 'Aberta':
        return { title: 'Venda Aberta', className: 'venda-aberta' };
      case 'Recebido':
        return { title: 'Venda Recebida', className: 'venda-recebida' };
      case 'Cancelada':
        return { title: 'Venda Cancelada', className: 'venda-cancelada' };
      case 'Agendada':
        return { title: 'Venda Agendada', className: 'venda-agendada' };
      default:
        return { title: null, className: null };
    }
  }

  temCobrancaRecebida(venda: any) {
    let temCobrancaRecebida = false;

    if (venda && venda.Cobrancas && venda.Cobrancas.length > 0) {
      venda.Cobrancas.forEach((cobranca: any) => {
        if (cobranca.Situacao === 'Recebido') {
          temCobrancaRecebida = true;
        }
      });
    }

    return temCobrancaRecebida;
  }

  obterData(data: any) {
    return moment(data).format('DD/MM/YYYY');
  }

  obterValorReal(valor: number) {
    return valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  }

  obterClasseBandeira(bandeira: string) {
    return bandeira.toLocaleLowerCase();
  }

  reativarVenda() {
    if (this.sale && this.sale.VendaId) {
      this.eventClose();
      this.fecharAlertaReativarVenda();
      this.irParaCheckout(this.sale.VendaId);
    }
  }

  cancelarVenda() {
    this.cancelandoVenda = true;
    if (this.sale && this.sale.VendaId) {
      this.vendaService.cancelarVenda(this.sale.VendaId).subscribe(() => {
        this.vendaCancelada = true;
        this.cancelandoVenda = false;

        const vendaAtual = this.vendas.find((venda: any) => venda.VendaId === this.sale.VendaId);

        if (vendaAtual) {
          vendaAtual.Situacao = 'Cancelada';
        }
      }, (err) => {
        this.vendaCancelada = false;
        this.cancelandoVenda = false;
        console.error(err);
      });
    }
  }

  alterarCartao() {
    if (this.sale && this.sale.VendaId) {
      this.irParaCheckout(this.sale.VendaId);
    }
  }

  irParaCheckout(vendaId: string) {
    window.open(window.location.origin + '/#/checkout?vendaId=' + vendaId, '_blank');
  }

  abrirAlertaCancelarVenda() {
    this.alertCancelarVenda = true;
  }

  fecharAlertaCancelarVenda() {
    this.alertCancelarVenda = false;

    if (this.vendaCancelada) {
      this.showModal = false;
      this.vendaCancelada = false;

      this.getVendas(0);
    }
  }

  abrirAlertaReativarVenda() {
    this.alertReativarVenda = true;
  }

  fecharAlertaReativarVenda() {
    this.alertReativarVenda = false;
  }

  filter() {
    this.filterByClientAndDescription(false);

    if (this.vendas.length === 0) {
      this.error = true;
      this.loaded = false;

      $('#master-detail-table-vendas_wrapper').hide();

      return;
    } else {
      this.error = false;
      this.loaded = true;
    }

    this.vendas.sort(function(a, b) {
      const dateA = a.DataCadastro;
      const dateB = b.DataCadastro;
      if (moment(dateA).isAfter(dateB)) { return -1; }
      if (!moment(dateA).isAfter(dateB)) { return 1; }
      return 0;
    });

    $('#master-detail-table-vendas_wrapper').show();

    if (this.table) {
      this.table.destroy();
      this.showData();
    } else {
      this.showData();
    }
  }

  filterByClientAndDescription(init: boolean) {
    this.vendas = init ? this.vendas : this._vendas;

    const _status = [];
    this.status.forEach((s: any) => {
      if (s.actived) { _status.push(s.name); }
    });


    if (_status.length > 0) {
      const _vendas = this.vendas.filter((venda) => {
        const statusAtivo = this.status.find(((s: any) => s.name === 'Ativa'));
        const statusAberto = this.status.find(((s: any) => s.name === 'Aberta'));

        if (venda.Situacao === 'Aberta') {
          if (statusAtivo && statusAtivo.actived && this.temCobrancaRecebida(venda) || (statusAberto && statusAberto.actived && !this.temCobrancaRecebida(venda))) {
            return true;
          } else {
            return false;
          }
        }

        return _status.indexOf(venda.Situacao) > -1;
      });

      this.vendas = JSON.parse(JSON.stringify(_vendas));
    }

    if (this.inputSearch.length > 0) {
      this.vendas = this.vendas.filter((venda) => {
        if (
          (venda.Descricao && venda.Descricao.toLowerCase().includes(this.inputSearch.toLowerCase())) ||
          (venda.Cliente && venda.Cliente.Nome && venda.Cliente.Nome.toLowerCase().includes(this.inputSearch.toLowerCase()))
        ) {
          return true;
        } else {
          return false;
        }
      });
    }

    if (this.inputSearch.length === 0 && _status.length === 0) {
      this.vendas = this._vendas;
    }
  }

  toggleBox() {
    this.boxHidden = !this.boxHidden;
  }

  markTagAsActive(value) {
    this.status.forEach((s) => {
      if (s.name === value) {
        s.actived = true;
      }
    });

    this.filter();
  }

  markTagAsInactive(value) {
    this.status.forEach((s) => {
      if (s.name === value) {
        s.actived = false;
      }
    });

    this.filter();
  }

  changeTag(e, value) {
    if (this.tagglejs.tag.values.length >= 2) {
      return;
    }

    if (e.target.checked) {
      this.addTag(value);
      this.markTagAsActive(value);

      e.target.checked = false;
    }
  }

  addTag(value) {
    this.tagglejs.add(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/vendas/vendas.component.ts